import {
  GET_FILE_TOKEN_REQUEST,
  GET_FILE_TOKEN_SUCCESS,
  GET_FILE_TOKEN_FAILURE,
  CLEAR_TOKEN_RESPONSE,
} from "../actionTypes";

import edi from "../service/cbp";

const getFileToken = () => {
  return {
    type: GET_FILE_TOKEN_REQUEST,
  };
};

const getFileTokenSuccess = (token) => {
  return {
    type: GET_FILE_TOKEN_SUCCESS,
    payload: token,
  };
};

const getFileTokenFailure = (error) => {
  return {
    type: GET_FILE_TOKEN_FAILURE,
    payload: error,
  };
};
export const clearTokenResponse = (error) => {
  return {
    type: CLEAR_TOKEN_RESPONSE,
  };
};

export const GetfileToken = (shipmentid, email, requestid, reason) => {
  return async (dispatch) => {
    dispatch(getFileToken());
    let response = await edi.GetFileToken(shipmentid, email, requestid, reason);
    const tokenData = response.data;
    await dispatch(getFileTokenSuccess(tokenData));
  };
};
